import React, { useState } from 'react';
import apiClient from '../api/client';
import './Auth.css';

export default function ReferralForm() {
  const [form, setForm] = useState({
    partnerOrganizationName: '', partnerContactName: '', partnerContactEmail: '', partnerContactPhone: '',
    patientFullName: '', patientEmail: '', patientPhone: '', reasonForReferral: '', urgency: 'routine',
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [busy, setBusy] = useState(false);

  function update(field, value) {
    setForm((f) => ({ ...f, [field]: value }));
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      await apiClient.post('/referrals', form);
      setSuccess('Referral received. Our team will follow up shortly.');
      setForm({
        partnerOrganizationName: '', partnerContactName: '', partnerContactEmail: '', partnerContactPhone: '',
        patientFullName: '', patientEmail: '', patientPhone: '', reasonForReferral: '', urgency: 'routine',
      });
    } catch (err) {
      setError(err.response?.data?.message || 'Could not submit referral');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="auth-page">
      <div className="card auth-card" style={{ maxWidth: 560 }}>
        <h1>Refer a Client</h1>
        <p className="auth-subtitle">
          For hospitals, NGOs, schools, and employers referring someone into our care.
        </p>

        {error && <div className="alert alert-error">{error}</div>}
        {success && <div className="alert alert-success">{success}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-field">
            <label htmlFor="org">Your organization</label>
            <input id="org" value={form.partnerOrganizationName} onChange={(e) => update('partnerOrganizationName', e.target.value)} />
          </div>
          <div className="form-field">
            <label htmlFor="contactName">Your name</label>
            <input id="contactName" value={form.partnerContactName} onChange={(e) => update('partnerContactName', e.target.value)} />
          </div>
          <div className="form-field">
            <label htmlFor="contactEmail">Your email</label>
            <input id="contactEmail" type="email" value={form.partnerContactEmail} onChange={(e) => update('partnerContactEmail', e.target.value)} />
          </div>
          <div className="form-field">
            <label htmlFor="contactPhone">Your phone</label>
            <input id="contactPhone" value={form.partnerContactPhone} onChange={(e) => update('partnerContactPhone', e.target.value)} />
          </div>
          <hr style={{ border: 'none', borderTop: '1px solid var(--color-border)', margin: '16px 0' }} />
          <div className="form-field">
            <label htmlFor="patientName">Client's full name</label>
            <input id="patientName" required value={form.patientFullName} onChange={(e) => update('patientFullName', e.target.value)} />
          </div>
          <div className="form-field">
            <label htmlFor="patientEmail">Client's email (if available)</label>
            <input id="patientEmail" type="email" value={form.patientEmail} onChange={(e) => update('patientEmail', e.target.value)} />
          </div>
          <div className="form-field">
            <label htmlFor="patientPhone">Client's phone (if available)</label>
            <input id="patientPhone" value={form.patientPhone} onChange={(e) => update('patientPhone', e.target.value)} />
          </div>
          <div className="form-field">
            <label htmlFor="reason">Reason for referral</label>
            <textarea id="reason" rows={4} value={form.reasonForReferral} onChange={(e) => update('reasonForReferral', e.target.value)} />
          </div>
          <div className="form-field">
            <label htmlFor="urgency">Urgency</label>
            <select id="urgency" value={form.urgency} onChange={(e) => update('urgency', e.target.value)}>
              <option value="routine">Routine</option>
              <option value="urgent">Urgent</option>
              <option value="emergency">Emergency — needs immediate attention</option>
            </select>
          </div>
          <button className="btn btn-primary" disabled={busy}>{busy ? 'Submitting…' : 'Submit Referral'}</button>
        </form>
      </div>
    </div>
  );
}
